import { Stack } from '@mui/material'
import { ReactNode } from 'react'
import pxToRem from '../../helpers/pxToRem'

export const DrawerIcon = (label: string, Icon: ReactNode) => {
    return (
        <Stack direction="row" alignItems={'center'} gap={pxToRem(8)}>
            {label}
            {Icon}
        </Stack>
    )
}
